import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PasswordStrengthMeter from "../PasswordStrengthMeter";
import TooltipComponent from "../../component/TooltipComponent";
import { toast } from "react-toastify";
import { ConfirmationComponent } from "../ConfirmationComponent";
import { LoaderPage } from "../../component/Loader";
import { withRouter } from "react-router-dom";
import {
  PHONE_VALIDATE,
  EMAIL_VALIDATE,
  DEFAULT_VALIDATION,
  PASSWORD_VALIDATE,
  USER_EXIST,
  ONLY_CHARS_NUM,
  VALIDATE_USER_ID,
  NAME_VALIDATE
} from "../../validation";
import { Form, Button, InputGroup } from "react-bootstrap";
import { sendSignUpOtp, isUserExist } from "../../actions/signup.action";
import { ERROR_MSG, STATUS } from "../../constant";
import TermsCondition from "../footer/TermsConditions";
import PrivacyPolicy from "../footer/PrivacyPolicy";
import pdfFile from "../../assets/pdf/PMG Project Proponent (Private) Manual.pdf";
import { successToastStyle, errorToastStyle } from "../../customToast";
import { truncateData } from "../../helper";
export class RegistrationForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userId: "",
      telCode: "",
      mobileNumber: "",
      email: "",
      password: "",
      confirmPassword: "",
      name: "",
      designation: "",
      organization: "",
      address: "",
      errors: {},
      type: "password",
      submitBtnText: "Register",
      dataChangeStatus: false,
      passwordMatched: false
    };
  }

  handleChange = event => {
    const { name, value } = event.target;

    this.setState({
      [name]: value,
      dataChangeStatus: true
    });
  };

  handleUserNameChange = event => {
    let { errors } = this.state;
    let pasted = this.state.pasted;
    let userName = this.state.name;
    let nameInputValue = event.target.value;
    if (pasted) {
      errors.nameValid = NAME_VALIDATE(nameInputValue);
      userName = truncateData(nameInputValue);
      this.setState({
        name: userName
      });
    } else {
      let currentNameValue = this.state.name;
      errors.nameValid = NAME_VALIDATE(nameInputValue);
      if (currentNameValue.length < 30 || nameInputValue.length < 31) {
        this.setState({
          name: nameInputValue
        });
      }
    }

    this.setState({
      pasted: false
    });
  };

  handleUserNamePaste = event => {
    this.setState({
      pasted: true
    });
  };

  handleIsUserExist = async event => {
    const { userId, errors } = this.state;
    const errorRef = { ...errors };
    const response = await isUserExist(undefined, { userId });
    if (response && response.data && !response.data.status) {
      errorRef.userIdValid = USER_EXIST(true, userId, "User");
      errorRef.userIdValidExist = errorRef.userIdValid;
      this.setState({
        errors: errorRef
      });
    } else {
      errorRef.userIdValid = USER_EXIST(false, userId, "User");
      errorRef.userIdValidExist = errorRef.userIdValid;
      this.setState({
        errors: errorRef
      });
    }
  };

  handleIsMobileNoExist = async event => {
    const { mobileNumber, errors } = this.state;
    const errorRef = { ...errors };
    const response = await isUserExist(undefined, { mobileNumber });
    if (response && response.data && !response.data.status) {
      errorRef.phoneValid = USER_EXIST(true, mobileNumber, "Mobile number");
      errorRef.phoneValidExist = errorRef.phoneValid;
      this.setState({
        errors: errorRef
      });
    } else {
      errors.phoneValid = USER_EXIST(false, mobileNumber, "Mobile number");
      errorRef.phoneValidExist = errorRef.phoneValid;
      this.setState({
        errors: errorRef
      });
    }
  };

  handleIsEmailExist = async event => {
    const { email, errors } = this.state;
    const errorRef = { ...errors };
    const response = await isUserExist(undefined, { email });
    if (response && response.data && !response.data.status) {
      errorRef.emailValid = USER_EXIST(true, email, "Email Address");
      errorRef.emailValidExist = errorRef.emailValid;
      this.setState({
        errors: errorRef
      });
    } else {
      errorRef.emailValid = USER_EXIST(false, email, "Email Address");
      errorRef.emailValidExist = errorRef.emailValid;
      this.setState({
        errors: errorRef
      });
    }
  };

  componentWillReceiveProps(nextProps, nextContext) {
    const oldProps = this.props;
    if (
      !nextProps.mobileNumber !== "" &&
      oldProps.mobileNumber !== nextProps.mobileNumber
    ) {
      this.setState({ mobileNumber: nextProps.mobileNumber });
    }
    if (!nextProps.email !== "" && oldProps.email !== nextProps.email) {
      this.setState({ email: nextProps.email });
    }
  }

  validateField = (fieldName, value) => {
    let {
      errors,
      userId,
      mobileNumber,
      email,
      password,
      confirmPassword,
      name,
      designation,
      organization,
      address,
      dataChangeStatus,
      alternateMobileNumber
    } = this.state;
    switch (fieldName) {
      case "userId":
        errors.userIdValid = VALIDATE_USER_ID(value, "User ID");
        if (errors.userIdValid.error === false) {
          this.handleIsUserExist();
        }
        break;
      case "mobileNumber":
        errors.phoneValid = PHONE_VALIDATE(value);
        if (errors.phoneValid.error === false) {
          this.handleIsMobileNoExist();
        }
        break;
      case "alternateMobileNumber":
        if (value) {
          errors.alternateMobileNumber = PHONE_VALIDATE(value);
        } else {
          delete errors.alternateMobileNumber;
        }
        break;
      case "email":
        errors.emailValid = EMAIL_VALIDATE(value);
        if (errors.emailValid.error === false) {
          this.handleIsEmailExist();
        }
        break;
      case "password":
        errors.passwordValid = PASSWORD_VALIDATE(value);
        break;
      case "confirmPassword":
        errors.confirmPasswordValid = PASSWORD_VALIDATE(value, password);
        break;
      case "name":
        errors.nameValid = {
          error: !name,
          message: !name && ERROR_MSG.NAME_REQUIRED
        };
        break;
      case "designation":
        errors.designationValid = {
          error: !designation,
          message: !designation && ERROR_MSG.DESIGNATION_REQUIRED
        };
        break;
      case "organization":
        errors.organizationValid = DEFAULT_VALIDATION(value, "Organization");
        break;
      case "address":
        errors.addressValid = DEFAULT_VALIDATION(value, "Address");
        break;
      default:
        // errors.userIdValid = ONLY_CHARS_NUM(userId, "User ID");
        errors.userIdValid = VALIDATE_USER_ID(userId, "User ID");
        errors.phoneValid = PHONE_VALIDATE(mobileNumber);
        if (alternateMobileNumber) {
          errors.alternateMobileNumber = PHONE_VALIDATE(alternateMobileNumber);
        } else {
          delete errors.alternateMobileNumber;
        }
        errors.emailValid = EMAIL_VALIDATE(email);
        errors.passwordValid = PASSWORD_VALIDATE(password);
        errors.confirmPasswordValid = PASSWORD_VALIDATE(
          confirmPassword,
          password
        );
        errors.nameValid = {
          error: !name,
          message: !name && ERROR_MSG.NAME_REQUIRED
        };
        errors.designationValid = {
          error: !designation,
          message: !designation && ERROR_MSG.DESIGNATION_REQUIRED
        };
        errors.organizationValid = DEFAULT_VALIDATION(
          organization,
          "Organization"
        );
        errors.addressValid = DEFAULT_VALIDATION(address, "Address");
        if (dataChangeStatus) {
          this.handleIsUserExist();
          this.handleIsMobileNoExist();
          this.handleIsEmailExist();
          this.setState({
            dataChangeStatus: false
          });
        }
        break;
    }
    this.setState({
      errors: { ...errors }
    });
  };

  validateForm = () => {
    let { errors } = this.state;
    let {
      nameValid,
      phoneValid,
      emailValid,
      passwordValid,
      organizationValid,
      confirmPasswordValid,
      designationValid,
      phoneValidExist,
      emailValidExist,
      userIdValidExist,
      alternateMobileNumber: alternateMobileNumberError
    } = errors;

    if (alternateMobileNumberError && alternateMobileNumberError.error) {
      return false;
    }

    return (
      (passwordValid &&
        passwordValid.error &&
        phoneValid &&
        phoneValid.error &&
        emailValid &&
        emailValid.error &&
        confirmPasswordValid &&
        confirmPasswordValid.error &&
        nameValid &&
        nameValid.error &&
        organizationValid &&
        organizationValid.error &&
        designationValid &&
        designationValid.error) !== undefined &&
      !passwordValid.error &&
      !phoneValid.error &&
      !emailValid.error &&
      !confirmPasswordValid.error &&
      !phoneValidExist.error &&
      !emailValidExist.error &&
      !userIdValidExist.error &&
      !nameValid.error &&
      !organizationValid.error &&
      !designationValid.error
    );
  };

  showPassword = e => {
    e.preventDefault();
    e.stopPropagation();
    const { type } = this.state;
    this.setState({
      type: type === "password" ? "text" : "password"
    });
  };

  handleOtpModal = async event => {
    // event.preventDefault();
    const { handleShow } = this.props;
    const {
      userId,
      mobileNumber,
      email,
      password,
      name,
      designation,
      organization,
      alternateMobileNumber,
      address
    } = this.state;
    // this.validateField();
    let isValidData = this.validateForm();
    let params = {};
    if (alternateMobileNumber && alternateMobileNumber.trim()) {
      params["alternateMobileNumber"] = alternateMobileNumber;
    }
    const data = {
      designation,
      email,
      mobileNumber,
      name,
      password,
      userID: userId,
      organization,
      address,
      ...params
    };

    if (isValidData) {
      this.setState({
        isApiLoading: STATUS.LOADING
      });
      let otpResult = await sendSignUpOtp(undefined, {
        email: data.email,
        service: "REGISTER",
        mobileNumber: data.mobileNumber
      });
      if (otpResult && otpResult.data.status) {
        toast.success(
          <p className="toast-text-alignment">{otpResult.data.message}</p>,
          successToastStyle
        );
      } else if (otpResult && !otpResult.data.status) {
        toast.error(
          <p className="toast-text-alignment">{otpResult.data.message}</p>,
          errorToastStyle
        );
      }
      this.setState({
        isApiLoading: STATUS.SUCCESS,
        showAlert: false
      });
      handleShow(data);
    }
  };

  restrictSpace = event => {
    let key = event ? event.which : window.event.keyCode;
    if (key === 32) {
      event.preventDefault();
    }
  };

  openConfirmationAlert = () => {
    this.validateField();
    let isValidData = this.validateForm();
    if (isValidData) {
      this.setState(prevState => ({
        showAlert: !prevState.showAlert
      }));
    }
  };

  closeReadBannerModal = () => {
    this.setState({ isBannerModalVisible: false });
  };

  showReadBannerModal = key => {
    this.setState({ isBannerModalVisible: true, bannerContent: key });
  };

  checkForMatched = confirmPassword => {
    let { password } = this.state;
    this.setState({
      passwordMatched: confirmPassword && confirmPassword === password
    });
  };

  render() {
    const {
      type,
      submitBtnText,
      userId,
      mobileNumber,
      email,
      password,
      confirmPassword,
      name,
      designation,
      organization,
      address,
      errors,
      showAlert,
      isApiLoading,
      bannerContent,
      alternateMobileNumber,
      isBannerModalVisible,
      passwordMatched
    } = this.state;
    const { loading } = this.props;
    const tooltipContent =
      "User ID is a unique sequence of characters used to identify a user. E.g. PPAmit";
    return (
      <React.Fragment>
        <LoaderPage loading={isApiLoading === STATUS.LOADING} />
        <ConfirmationComponent
          show={showAlert}
          isLoading={loading}
          modalClass={"confirmation-modal"}
          saveHandler={this.handleOtpModal}
          closeHandler={this.openConfirmationAlert}
          content={"Are you sure you want to do this?"}
        />

        <p className="register-note">
          Note - This Registration Form is ONLY for Private Project Proponents.
          If you belong to any government ministry/ department/ organization/
          PSU kindly contact your respective Nodal Officer/ PMG Team to create
          your user ID.
          <a
            href={pdfFile}
            type="application/pdf"
            target="_blank"
            data-test="pmg-manual-download"
            rel="noreferrer"
          >
            Project Monitoring Group Manual : Project Proponent (Private)
          </a>
        </p>

        <div className="register-inner register-wrapper">
          <h1 className="page-heading hide-heading">
            Register
            {/* <span className="heading-subtext">
              [<strong className="required">*</strong> indicates mandatory
              fields]
            </span>*/}
          </h1>
          {/*<p className="page-sub-heading">
            We only consider issues of projects above <span>₹500cr</span>
          </p>*/}
          <Form noValidate className="signup-form">
            <Form.Group controlId="userId">
              <Form.Label>
                User ID<span className="required">*</span>{" "}
                <TooltipComponent content={tooltipContent} />
              </Form.Label>
              <Form.Control
                name="userId"
                type="text"
                value={userId}
                onChange={this.handleChange}
                onBlur={() => this.validateField("userId", userId)}
                isInvalid={
                  (errors.userIdValid && errors.userIdValid.error) ||
                  (errors.userIdValidExist && errors.userIdValidExist.error)
                }
                placeholder="Create UserId"
              />
              <Form.Control.Feedback type="invalid">
                {errors.userIdValid && errors.userIdValid.error
                  ? errors.userIdValid.message
                  : null}
                {errors.userIdValidExist &&
                errors.userIdValidExist.error &&
                !errors.userIdValid.error
                  ? errors.userIdValidExist.message
                  : null}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="mobileNumber">
              <Form.Label>
                {" "}
                Mobile Number<span className="required">*</span>
              </Form.Label>
              <InputGroup>
                <InputGroup.Prepend>
                  <InputGroup.Text id="inputGroupPrepend">+91</InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control
                  name="mobileNumber"
                  type="text"
                  maxLength="10"
                  value={mobileNumber}
                  onChange={this.handleChange}
                  onBlur={() =>
                    this.validateField("mobileNumber", mobileNumber)
                  }
                  isInvalid={
                    (errors.phoneValid && errors.phoneValid.error) ||
                    (errors.phoneValidExist && errors.phoneValidExist.error)
                  }
                  placeholder="10-digit Mobile Number"
                />
                <Form.Control.Feedback type="invalid">
                  {errors.phoneValid && errors.phoneValid.error
                    ? errors.phoneValid.message
                    : null}
                  {errors.phoneValidExist &&
                  errors.phoneValidExist.error &&
                  !errors.phoneValid.error
                    ? errors.phoneValidExist.message
                    : null}
                </Form.Control.Feedback>
              </InputGroup>
            </Form.Group>

            <Form.Group controlId="mobileNumber">
              <Form.Label> Alternate Mobile Number</Form.Label>
              <InputGroup>
                <InputGroup.Prepend>
                  <InputGroup.Text id="inputGroupPrepend">+91</InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control
                  name="alternateMobileNumber"
                  type="text"
                  maxLength="10"
                  value={alternateMobileNumber}
                  onChange={this.handleChange}
                  onBlur={() => {
                    this.validateField(
                      "alternateMobileNumber",
                      alternateMobileNumber
                    );
                  }}
                  isInvalid={
                    errors.alternateMobileNumber &&
                    errors.alternateMobileNumber.error
                  }
                />
                <Form.Control.Feedback type="invalid">
                  {errors.alternateMobileNumber &&
                  errors.alternateMobileNumber.error
                    ? errors.alternateMobileNumber.message
                    : null}
                </Form.Control.Feedback>
              </InputGroup>
            </Form.Group>

            <Form.Group controlId="email">
              <Form.Label>
                {" "}
                Official E-mail ID<span className="required">*</span>{" "}
              </Form.Label>
              <Form.Control
                name="email"
                type="email"
                value={email}
                onChange={this.handleChange}
                onBlur={() => this.validateField("email", email)}
                isInvalid={
                  (errors.emailValid && errors.emailValid.error) ||
                  (errors.emailValidExist && errors.emailValidExist.error)
                }
                placeholder="example@gmail.com"
              />
              <Form.Control.Feedback type="invalid">
                {errors.emailValid && errors.emailValid.error
                  ? errors.emailValid.message
                  : null}
                {errors.emailValidExist &&
                errors.emailValidExist.error &&
                !errors.emailValid.error
                  ? errors.emailValidExist.message
                  : null}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="password">
              <Form.Label>
                {" "}
                Password<span className="required">*</span>{" "}
              </Form.Label>
              <Form.Control
                name="password"
                type={type}
                value={password}
                onChange={this.handleChange}
                onBlur={() => {
                  this.validateField("password", password);
                  this.checkForMatched(confirmPassword);
                }}
                onKeyPress={this.restrictSpace}
                isInvalid={errors.passwordValid && errors.passwordValid.error}
                placeholder="Password"
              />
              <Form.Control.Feedback type="invalid">
                {errors.passwordValid && errors.passwordValid.error
                  ? errors.passwordValid.message
                  : null}
              </Form.Control.Feedback>
            </Form.Group>

            <PasswordStrengthMeter password={password} />

            <Form.Group
              controlId="confirmPassword"
              className="confirm-password"
            >
              {/* class when password & confirm password matches - valid */}
              <Form.Label>
                {" "}
                Retype Password<span className="required">*</span>{" "}
              </Form.Label>
              <Form.Control
                name="confirmPassword"
                type={type}
                value={confirmPassword}
                onChange={this.handleChange}
                onBlur={() => {
                  this.validateField("confirmPassword", confirmPassword);
                  this.checkForMatched(confirmPassword);
                }}
                onKeyPress={this.restrictSpace}
                isInvalid={
                  errors.confirmPasswordValid &&
                  errors.confirmPasswordValid.error
                }
                placeholder="Confirm Password"
              />
              <Form.Control.Feedback type="invalid">
                {errors.confirmPasswordValid &&
                errors.confirmPasswordValid.error
                  ? errors.confirmPasswordValid.message
                  : null}
                {/*{confirmPassword && password !== confirmPassword ? (*/}
                {/*  <p>Passwords dont match</p>*/}
                {/*) : null}*/}
              </Form.Control.Feedback>
              {passwordMatched ? (
                <span className="password-matched">Password Matched</span>
              ) : null}
            </Form.Group>

            <Form.Group controlId="name">
              <Form.Label>
                {" "}
                Your Name<span className="required">*</span>{" "}
              </Form.Label>
              <Form.Control
                name="name"
                type="text"
                value={name}
                onChange={this.handleUserNameChange}
                onPaste={this.handleUserNamePaste}
                onBlur={() => this.validateField("name", name)}
                isInvalid={errors.nameValid && errors.nameValid.error}
                placeholder="Enter Full Name"
              />
              <Form.Control.Feedback type="invalid">
                {errors.nameValid && errors.nameValid.error
                  ? errors.nameValid.message
                  : null}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="designation">
              <Form.Label>
                {" "}
                Designation<span className="required">*</span>{" "}
              </Form.Label>
              <Form.Control
                name="designation"
                type="text"
                value={designation}
                onChange={this.handleChange}
                onBlur={() => this.validateField("designation", designation)}
                isInvalid={
                  errors.designationValid && errors.designationValid.error
                }
                placeholder="Enter Designation"
              />
              <Form.Control.Feedback type="invalid">
                {errors.designationValid && errors.designationValid.error
                  ? errors.designationValid.message
                  : null}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="organization">
              <Form.Label>
                {" "}
                Organization <span className="required">*</span>
              </Form.Label>
              <Form.Control
                name="organization"
                type="text"
                value={organization}
                onChange={this.handleChange}
                onBlur={() => this.validateField("organization", organization)}
                isInvalid={
                  errors.organizationValid && errors.organizationValid.error
                }
                placeholder="Enter Organization"
              />
              <Form.Control.Feedback type="invalid">
                {errors.organizationValid && errors.organizationValid.error
                  ? errors.organizationValid.message
                  : null}
              </Form.Control.Feedback>
            </Form.Group>
            {/* <Form.Group controlId="address">
              <Form.Label> Address </Form.Label>
              <Form.Control
                name="address"
                type="text"
                value={address}
                onChange={this.handleChange}
                onBlur={() => this.validateField("address", address)}
                placeholder="Enter Full Address"
              />
            </Form.Group> */}

            <Button
              variant="primary"
              type="button"
              className="btn-orange full-width"
              data-test={submitBtnText + "-button"}
              onClick={this.openConfirmationAlert}
            >
              {submitBtnText}
            </Button>
            <div className="term-use">
              By clicking "Register" I agree to{" "}
              <span
                onClick={() => this.showReadBannerModal("termsConditions")}
                data-test="terms-of-service"
              >
                Terms of Service
              </span>{" "}
              &{" "}
              <span
                onClick={() => this.showReadBannerModal("privacyPolicy")}
                data-test="privacy-policy"
              >
                Privacy Policy
              </span>
              .
            </div>
          </Form>
          {bannerContent === "termsConditions" ? (
            <TermsCondition
              show={isBannerModalVisible}
              closeModal={this.closeReadBannerModal}
            />
          ) : null}
          {bannerContent === "privacyPolicy" ? (
            <PrivacyPolicy
              show={isBannerModalVisible}
              closeModal={this.closeReadBannerModal}
            />
          ) : null}
        </div>
      </React.Fragment>
    );
  }
}

RegistrationForm.propTypes = {
  history: PropTypes.shape({})
};

RegistrationForm.defaultProps = {
  history: {}
};

function mapStateToProps(state) {
  return {
    otpResult: state.loginReducer.otpData,
    loading: state.loginReducer.loginStatus
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      sendSignUpOtp: sendSignUpOtp
    },
    dispatch
  );
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(RegistrationForm)
);

// export default withToastManager(connect()(RegistrationForm));
